import { Zmaterialdetails } from './zmaterialdetails';

export interface Fitments {
    fitted: Zmaterialdetails[];
    options: Zmaterialdetails[];
}

export function createFitments(): Fitments {
    return {
        fitted: [],
        options: []
    };
}